export default class CouponController {
  constructor(CouponsDataProvider) {
    "ngInject"
    this.CouponsDataProvider = CouponsDataProvider;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.field = 'id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.getCoupons();
    this.checkboxes = [];
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getCoupons();
  }

  getCoupons() {
    let
      vm = this;
    let data = {};
    let searchData = {};
    searchData.name = vm.name;
    searchData.code = vm.code;
    searchData.type = vm.type;
    searchData.price_to = vm.price_to;
    searchData.price_from = vm.price_from;
    searchData.used_count = vm.used_count;
    searchData.status = vm.status;
    data.searchData = searchData;
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    vm.CouponsDataProvider.getCoupons(data, searchData).then(function (result) {
      vm.coupons = result.data;
      vm.couponsTotal = result.total;
      vm.selectall = false;
    });
  }

  changeStatus() {
    if (!this.status_change) {
      return false;
    }
    if (this.checkboxes.length == 0) {
      alert('please select coupon first');
      return false;
    }
    let
      vm = this;
    let
      data = {'status': vm.status_change, 'ids': vm.checkboxes}
    vm.CouponsDataProvider.updateCouponStatus(data).then(function (resp) {
      vm.pages = resp;
      vm.getCoupons();
      vm.checkboxes = [];
    })
  }

  changeStatusSingle(status, id) {
    let
      data = {'status': status};
    this.updateCoupon(data, id);
  }

  updateCoupon(data, id) {
    let
      vm = this;
    vm.CouponsDataProvider.updateCoupon(data, id).then(function (resp) {
      vm.getCoupons();
    })
  }

  removeCoupon(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.CouponsDataProvider.removeCoupon(id).then(function (res) {
      vm.getCoupons();
    })
  }

  clearFilter() {
    this.name = '';
    this.code = '';
    this.type = '';
    this.price_from = '';
    this.price_to = '';
    this.used_count = '';
    this.status = '';
    this.getCoupons();
  }

  checkbox(id, check) {
    let
      index = this.checkboxes.indexOf(id);
    if (check == true) {
      if (index == '-1') {
        this.checkboxes.push(id);
      }
    }
    else {
      this.checkboxes.splice(index, 1);
    }
  }

  checkAll() {
    if (this.selectall) {
      let vm = this;
      angular.forEach(this.coupons, function (coupon) {
        coupon.checked = 1;
        vm.checkboxes.push(coupon.id);
      });
    }
    else {
      angular.forEach(this.coupons, function (coupon) {
        coupon.checked = 0;
      });
      this.checkboxes = [];
    }
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/coupons/components/listing/controller.js
 **/